import { BaseModel } from './base.model';
import { Project } from './project.model';
import { Subsystem } from './subsystem.model';
import { Task } from './task.model';
import { EstimationDiffStatus } from './estimation-v3.types';

export interface Requirement {
  id: number;
  description: string;
  // priority: string;
  // status: string;
  creationDate: string;
  iscolapse: boolean;
  project: Project;
  subsystem: Subsystem;
  tasks: Task[];

  // ===== Estado del diff view (ya se usaba en HTML, ahora tipado) =====
  _diffStatus?: EstimationDiffStatus;
}

export class Requirement implements BaseModel {
  id: number;
  description: string;
  // priority: string;
  // status: string;
  creationDate: string;
  iscolapse: boolean;
  project: Project;
  subsystem: Subsystem;
  tasks: Task[];

  // Diff view
  _diffStatus?: EstimationDiffStatus;

  constructor();
  constructor(id: number, description: string, creationDate: string, iscolapse: boolean, project: Project, subsystem: Subsystem, tasks: Task[]);

  constructor(id?: number, description?: string, creationDate?: string, iscolapse?: boolean, project?: Project, subsystem?: Subsystem, tasks?: Task[]) {
    if (id !== undefined) {
      this.id = id;
    }

    if (description !== undefined) {
      this.description = description;
    } else {
      this.description = '';
    }

    if (creationDate !== undefined) {
      this.creationDate = creationDate;
    } else {
      this.creationDate = '';
    }

    if (iscolapse !== undefined) {
      this.iscolapse = iscolapse;
    } else {
      this.iscolapse = true;
    }

    if (project !== undefined) {
      this.project = project;
    } else {
      this.project = {} as Project;
    }

    if (subsystem !== undefined) {
      this.subsystem = subsystem;
    } else {
      this.subsystem = {} as Subsystem;
    }

    if (tasks !== undefined) {
      this.tasks = tasks;
    } else {
      this.tasks = [];
    }
  }

  getApiName(): string {
    return 'requirements';
  }

  getName(): string {
    return 'Requisito';
  }

  getNamePl(): string {
    return 'Requisitos';
  }
}